const initialState = {
  selectedVehicle: [],
};
const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ACTION_VEHICLE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
export default dataReducer;
